module.exports = __webpack_public_path__ + "static/img/tips4.59317406.png";